// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3JG_O","imageUploader":"EGiftCard_imageUploader__xjd7O"};